import React, { Component } from 'react';
import './App.css';
import {NavBar, MainContent, Footer, ScholarshipContent, DonateContent, RefundContent, PrivacyContent} from "./components/index"; //can list all components from the directory
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';

/*
1. Do we want to use a Bootstrap carousel? or a React component?
2. resize it to look good
3. look into navbar --> transparent background on the navbar
*/

class App extends Component {
  render() {
    return (
      <Router>
       <div className="App">
        <NavBar />
        {
          //<PageHeader />
        }
        <Route exact={true} path="/" render={() => (
          <div>
          {
            //<Carousel />
          }

          <MainContent />
          </div>

        )}/>
        <Switch>
          <Route exact={true} path="/donate" component={DonateContent}/>
          <Route exact={true} path="/scholarship" component={ScholarshipContent}/>
          <Route exact={true} path="/refund" component={RefundContent}/>
          <Route exact={true} path="/privacy" component={PrivacyContent}/>
        </Switch>
        <Footer />
        { /*
        <header className="App-header">
        <img src={background} className="App-logo" alt="logo" />
          <h1 className="App-title text-info">Walter M. Cunningham Education Foundation</h1>
        </header>
        <p className="App-intro">
          Please donate here.
        </p>*/
        }
      </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js